"use strict";

// Função para formatar o preço
function formatPrice(price) {
    return 'R$' + parseFloat(price).toLocaleString('pt-BR', {minimumFractionDigits: 2});
}

function formatPriceCart(preco) {
    let valorReal = preco / 100;
    let valorFormatado = valorReal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return valorFormatado;
}

//atualiza preços assinatura PDP
function updatePricesOnPageLoad() {
    const handleElement = document.getElementById('handleProduct');
    if (handleElement) {
        const handle = handleElement.value;

        let currentSku, counterpartSku;

        if (document.querySelector('.signature-variant__price.unica')) {
            currentSku = document.querySelector('input[name="id"]').getAttribute('data-sku').replace('SIG', '');
            counterpartSku = currentSku + 'SIG';
        } else {
            counterpartSku = document.querySelector('input[name="id"]').getAttribute('data-sku');
            currentSku = counterpartSku.replace('SIG', '');
        }

        const currentVariantElement = document.querySelector('.signature-variant__price.unica');
        const counterpartVariantElement = document.querySelector('.signature-variant__price.mensal');

        if (currentVariantElement && counterpartVariantElement) {
            fetch('/products/' + handle + '.json')
                .then(response => response.json())
                .then(data => {
                    const currentVariant = data.product.variants.find(variant => variant.sku === currentSku);
                    const counterpartVariant = data.product.variants.find(variant => variant.sku === counterpartSku);

                    if (currentVariant && counterpartVariant) {
                        let discount = 0;
                        if (counterpartVariant.compare_at_price > counterpartVariant.price) {
                            let discountAmount = counterpartVariant.compare_at_price - counterpartVariant.price;
                            discount = (discountAmount / counterpartVariant.compare_at_price) * 100;
                            discount = Math.round(discount)
                            document.querySelectorAll('.discountPriceSig').forEach(function(div) {
                                div.textContent = discount + '% OFF';
                            });
                        }

                        const formattedCurrentPrice = formatPrice(currentVariant.price);
                        const formattedCounterpartPrice = formatPrice(counterpartVariant.price);
                        currentVariantElement.textContent = formattedCurrentPrice;
                        counterpartVariantElement.textContent = formattedCounterpartPrice;
                    }
                });
        }
    }

    //active
    const signatureVariantLabels = document.querySelectorAll('.signature-variant label');
    signatureVariantLabels.forEach(label => {
        label.addEventListener('click', function() {
            const activeItems = document.querySelectorAll('.signature-variant ul li.active');
            activeItems.forEach(item => {
                item.classList.remove('active');
            });
            
            const listItem = label.closest('li');
            if (listItem) {
                listItem.classList.add('active');
            }
        });
    });
}

// Observer veriants change
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('main-product__block-price')) {
            updatePricesOnPageLoad();
        }
        if (mutation.target.classList.contains('cart-items')) {
             updateMinicartHandler();
             
             if (document.body.id === 'cart') {
                removeItemPageCart();
                checkSignaturesPageCart();
            }
        }
    });
});

const observerConfig = {
    attributes: true,
    childList: true,
    subtree: true
};


//minicart assinatura
function updateMinicartHandler() {
    let clickOnce = false;
    const signatureBtn = document.querySelectorAll('.btn-signature');
    let lineCurrent = '';
    let currentSku = '';
    let currentVariantId = '';
    let currentHandle = '';
    let currentVariantIdChange = '';
    let currentQtd = '';
    let thisCurrent = '';
    signatureBtn.forEach(signature => {
        signature.addEventListener('click', function() {
            //loading
            thisCurrent = this;
            thisCurrent.classList.add("loading");
            thisCurrent.nextElementSibling.style.display = 'block';
            lineCurrent = this.closest("tr").id.replace('CartItem-', '');
            currentSku = this.getAttribute('data-sku');
            currentVariantId = this.getAttribute('data-variantid');
            currentHandle = this.getAttribute('data-handle');
            currentQtd = this.getAttribute('data-qtd');
            fetch('/products/' + currentHandle + '.js')
            .then(response => {
                if (!response.ok) {
                throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if(currentSku.includes('SIG')){
                    //remove assinatura
                    currentSku = currentSku.replace('SIG', '');
                    for (let i = 0; i < data.variants.length; i++) {
                        if(data.variants[i].sku == currentSku){
                            currentVariantIdChange = data.variants[i].id;
                        }
                    }
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            updates: {
                                [currentVariantIdChange]: currentQtd
                            }
                        })
                      })
                      .then(response => {
                       // alert('Assinatura removida do carrinho');
                        
                        //remove produto anterior
                         fetch('/cart/update.js', {
                         method: 'POST',
                         headers: {
                             'Content-Type': 'application/json',
                         },
                         body: JSON.stringify({
                             updates: {
                             [currentVariantId]: 0 
                             }
                         })
                         })
                         .then(response => {
                            //reload pagina carrinho
                            if (document.body.id === 'cart') {
                                let mainCartItems = document.getElementById('MainCartItems');

                                fetch(window.location.href)
                                .then(response => response.text())
                                .then(data => {
                                    let tempElement = document.createElement('div');
                                    tempElement.innerHTML = data;
                                    mainCartItems.innerHTML = tempElement.querySelector('#MainCartItems').innerHTML;
                                    updateMinicartHandler()
                                    checkSignaturesPageCart();
                                })
                                .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
                            }else{
                                //reload minicart
                                let mainCartItems = document.getElementById('CartDrawer');

                                fetch(window.location.href)
                                .then(response => response.text())
                                .then(data => {
                                    //se tiver na pagina de carrinho reload
                                    if (document.body.id === 'cart') {
                                        let mainCartItems = document.getElementById('MainCartItems');
        
                                        fetch(window.location.href)
                                        .then(response => response.text())
                                        .then(data => {
                                            let tempElement = document.createElement('div');
                                            tempElement.innerHTML = data;
                                            mainCartItems.innerHTML = tempElement.querySelector('#MainCartItems').innerHTML;
                                            updateMinicartHandler()
                                        })
                                        .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
                                    }else{
                                        let tempElement = document.createElement('div');
                                        tempElement.innerHTML = data;
                                        mainCartItems.innerHTML = tempElement.querySelector('#CartDrawer').innerHTML;
                                        updateMinicartHandler()
                                    }
                                })
                                .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
                            }
                            
                            
                        })
                         .catch(error => {
                         console.error('Houve um erro ao remover o item do carrinho', error);
                         });
 
                      })
                      .catch(error => {
                        console.error('Erro3', error);
                      });
                }else{
                     //adicionando assinatura
                     currentSku = currentSku+'SIG';
                     for (let i = 0; i < data.variants.length; i++) {
                         if(data.variants[i].sku == currentSku){
                             currentVariantIdChange = data.variants[i].id;
                         }
                     }
                     fetch('/cart/update.js', {
                       method: 'POST',
                       headers: {
                         'Content-Type': 'application/json',
                       },
                       body: JSON.stringify({
                            updates: {
                                [currentVariantIdChange]: currentQtd
                            }
                       })
                     })
                     .then(response => {
                       //alert('Assinatura adicionada ao carrinho');
                       
                       //remove produto anterior
                        fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            updates: {
                            [currentVariantId]: 0
                            }
                        })
                        })
                        .then(response => {
                            //reload pagina carrinho
                            if(window.location.href.includes('/cart')){
                                let mainCartItems = document.getElementById('MainCartItems');

                                fetch(window.location.href)
                                .then(response => response.text())
                                .then(data => {
                                    let tempElement = document.createElement('div');
                                    tempElement.innerHTML = data;
                                    mainCartItems.innerHTML = tempElement.querySelector('#MainCartItems').innerHTML;
                                    updateMinicartHandler();
                                    checkSignaturesPageCart();
                                })
                                .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
                            }else{
                                //reload minicart
                                let mainCartItems = document.getElementById('CartDrawer');

                                fetch(window.location.href)
                                .then(response => response.text())
                                .then(data => {
                                    let tempElement = document.createElement('div');
                                    tempElement.innerHTML = data;
                                    mainCartItems.innerHTML = tempElement.querySelector('#CartDrawer').innerHTML;
                                    updateMinicartHandler()
                                })
                                .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
                            }
                            
                            
                        })
                        .catch(error => {
                            thisCurrent.classList.remove("active");
                            thisCurrent.nextElementSibling.style.display = 'none';
                            console.error('Houve um erro ao remover o item do carrinho', error);
                        });

                     })
                     .catch(error => {
                       console.error('Erro3', error);
                       thisCurrent.nextElementSibling.style.display = 'none';
                       document.querySelectorAll('#MainCartIems span.ico_loading').style.display = 'none';
                    });
                     
                }
            })
            .catch(error => {
                console.error('Erro2:', error);
                thisCurrent.nextElementSibling.style.display = 'none';
                document.querySelectorAll('#MainCartIems span.ico_loading').style.display = 'none';
            });
        });
    });
}




//remove item pagina cart
function removeItemPageCart() {
    document.body.addEventListener('click', function(event) {
      const clickedElement = event.target.closest('.cart-item__newremover');
  
      if (clickedElement) {
        const variantId = clickedElement.getAttribute('data-variant_id'); 
        fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            updates: {
            [variantId]: 0 
            }
        })
        })
        .then(response => {
        if (response.ok) {
            window.location.reload();
        } else {
            console.error('Failed to remove item from cart:', response.statusText);
        }
        })
        .catch(error => {
        console.error('Error removing item from cart:', error);
        });
      }
    });
  }
  

    //carrossel cart recomendadtion drag

    function scrollCartRecommendations() {
        let mouseDown = false;
        let startX, scrollLeft;
        const slider = document.querySelector('.carrossel-container .featured-collection');
        
        const startDragging = (e) => { 
            mouseDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            e.preventDefault();
            
        }
        
        const stopDragging = (e) => {
            mouseDown = false;
            e.preventDefault();
            return false;
        }
        
        const move = (e) => {
            e.preventDefault(); 
            if(!mouseDown) { return; }
            const x = e.pageX - slider.offsetLeft;
            const scroll = x - startX;
            slider.scrollLeft = scrollLeft - scroll;
            return false;
        } 
        
        // Add the event listeners
        if(slider !=null){
            slider.addEventListener('mousemove', move, false);
            slider.addEventListener('mousedown', startDragging, false);
            slider.addEventListener('mouseup', stopDragging, false);
            slider.addEventListener('mouseleave', stopDragging, false);
        }
    }

function notifyEmailProd(){
    var notifyMeButton = document.getElementById('notify-me');
    var notifyMeWrapper = document.getElementById('notify-me-wrapper');
    
    if(notifyMeButton) {
        notifyMeButton.addEventListener('click', function(e) {
        e.preventDefault();
        if(notifyMeWrapper) {
            notifyMeWrapper.style.display = 'block';
        }
        });
    }
}

//check assinaturas no carrinho
function checkSignaturesPageCart(){
    if (document.body.id === 'cart') {
        fetch('/cart.json')
        .then(response => response.json())
        .then(data => {
            let items = data.items;
            let noSigTotal = 0;
            let yesSigTotal = 0;
        
            let isSignatureCart = false;

            items.forEach(item => {
                if (item.sku.includes('SIG')) {
                    yesSigTotal += item.price * item.quantity;
                    isSignatureCart = true;
                } else {
                    noSigTotal += item.price * item.quantity;
                }
            });
        
            let container = document.querySelector('.conteinerTotalJs');

            if (isSignatureCart == false){
                let divs = document.querySelectorAll('.isSignatureCart');
                divs.forEach(div => {
                    div.style.display = 'none';
                });
            }
            
            // Limpa o conteúdo atual da div
            container.innerHTML = '';
        
            // Cria e adiciona a div para produtos sem 'SIG'
            let noSigDiv = document.createElement('div');
            noSigDiv.classList.add('noSig');
            
            let noSigSpanTitle = document.createElement('span');
            noSigSpanTitle.textContent = 'Produtos únicos:';
            
            let noSigSpanTotal = document.createElement('span');
            noSigSpanTotal.textContent = `${formatPriceCart(noSigTotal)}`;
            
            noSigDiv.appendChild(noSigSpanTitle);
            noSigDiv.appendChild(noSigSpanTotal);
            
            container.appendChild(noSigDiv);

            // Cria e adiciona a div para produtos com 'SIG'
            let yesSigDiv = document.createElement('div');
            yesSigDiv.classList.add('yesSig');
            
            let yesSigSpanTitle = document.createElement('span');
            yesSigSpanTitle.textContent = 'Produtos recorrentes:';
            
            let yesSigSpanTotal = document.createElement('span');
            yesSigSpanTotal.textContent = `${formatPriceCart(yesSigTotal)}`;
            
            yesSigDiv.appendChild(yesSigSpanTitle);
            yesSigDiv.appendChild(yesSigSpanTotal);
            
            container.appendChild(yesSigDiv);
        })
        .catch(error => console.error('Erro ao buscar dados:', error));
    }
}

function anchorDescription() {
    let btnViewMore = document.querySelectorAll('.btnViewMore, .shortDescription p');

    if (btnViewMore) {
      btnViewMore.forEach(btn => {
        btn.addEventListener('click', function(event) {
          event.preventDefault();
    
          let targetDiv = document.querySelector('.main-product__block-collapsible-tab');
    
          if (targetDiv) {
            window.scrollTo({
              top: targetDiv.offsetTop,
              behavior: 'smooth'
            });
    
            let buttonInsideDiv = targetDiv.querySelector('button');
            if (buttonInsideDiv) {
              buttonInsideDiv.click();
            }
          }
        });
      });
    }
}
  

// Função para mostrar preço quando assinatura está selecionada
function updateSubscriptionPriceDisplay() {
    const priceWrapper = document.querySelector('.main-product__block-price .price');
    if (!priceWrapper) return;
    
    let hasSellingPlan = false;
    
    // 1. Verifica selling plans nativos do Shopify (Shopify Subscriptions app)
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked');
    const sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
    
    if (sellingPlanInput && sellingPlanInput.value) {
        hasSellingPlan = true;
    } else if (sellingPlanSelect && sellingPlanSelect.value && sellingPlanSelect.value !== '' && sellingPlanSelect.value !== 'null') {
        hasSellingPlan = true;
    }
    
    // 2. Verifica purchase options (estrutura comum do Shopify Subscriptions)
    const purchaseOptionRadios = document.querySelectorAll('input[name*="purchase_option"], input[name*="purchase-option"], input[name="properties[_selling_plan_group]"]');
    for (let radio of purchaseOptionRadios) {
        if (radio.checked && radio.value && radio.value !== '' && radio.value !== 'null') {
            hasSellingPlan = true;
            break;
        }
    }
    
    // 3. Verifica estrutura específica do app Shopify Subscriptions
    const subscriptionRadio = document.querySelector('input[type="radio"][value*="subscription"]:checked, input[type="radio"][value*="recurring"]:checked');
    if (subscriptionRadio) {
        hasSellingPlan = true;
    }
    
    // 4. Verifica por qualquer radio que tenha texto relacionado a assinatura no DOM próximo
    const allRadios = document.querySelectorAll('input[type="radio"]:checked');
    for (let radio of allRadios) {
        const parentEl = radio.closest('div, fieldset, section');
        if (parentEl) {
            const parentText = parentEl.textContent.toLowerCase();
            if (parentText.includes('mensal') || parentText.includes('assinatura') || 
                parentText.includes('subscription') || parentText.includes('recurring')) {
                hasSellingPlan = true;
                break;
            }
        }
    }
    
    // Debug: log para verificar o que está sendo detectado
    console.log('Subscription detection:', {
        sellingPlanInput: !!sellingPlanInput,
        sellingPlanSelect: sellingPlanSelect ? sellingPlanSelect.value : null,
        hasSellingPlan: hasSellingPlan
    });
    
    // Adiciona ou remove classe para mostrar preço
    if (hasSellingPlan) {
        priceWrapper.classList.add('subscription-selected');
        console.log('Added subscription-selected class');
    } else {
        priceWrapper.classList.remove('subscription-selected');
        console.log('Removed subscription-selected class');
    }
}

// Observar alterações na div
document.addEventListener("DOMContentLoaded", function() {
    observer.observe(document.body, observerConfig);
    updatePricesOnPageLoad();
    updateMinicartHandler();
    removeItemPageCart();
    checkSignaturesPageCart();
    notifyEmailProd();
    anchorDescription();
    
    // Inicializar verificação de preço de assinatura
    updateSubscriptionPriceDisplay();
    
    // Observar mudanças no formulário do produto para selling plans e radios de assinatura
    document.addEventListener('change', function(e) {
        const target = e.target;
        if (target.name === 'selling_plan' || 
            target.type === 'radio' || 
            target.name && (target.name.includes('purchase') || target.name.includes('selling_plan'))) {
            setTimeout(updateSubscriptionPriceDisplay, 100); // pequeno delay para aguardar o DOM atualizar
        }
    });
    
    // Observar mudanças no DOM que possam vir do app de assinatura
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
        const formObserver = new MutationObserver(function(mutations) {
            let shouldUpdate = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    shouldUpdate = true;
                }
            });
            if (shouldUpdate) {
                setTimeout(updateSubscriptionPriceDisplay, 200);
            }
        });
        formObserver.observe(productForm, { 
            childList: true, 
            subtree: true, 
            attributes: true,
            attributeFilter: ['checked', 'selected', 'value']
        });
    }
    
    // Escutar especificamente por eventos do Shopify relacionados a variants/selling plans
    document.addEventListener('variant:change', updateSubscriptionPriceDisplay);
    document.addEventListener('selling_plan:change', updateSubscriptionPriceDisplay);
    
    if(window.innerWidth > 979){
        setTimeout(() => {
            scrollCartRecommendations();
        }, "800");
    }
});